import { __awaiter } from "tslib";
import { text, isValidInput, ValidationTypes, getBtnStatusClass, } from "@phoenixreisen/form";
import { changePassword } from "../model";
import User from "@phoenixreisen/user";
import m from "mithril";
const Link = m.route.Link;
const submit = (state, e) => __awaiter(void 0, void 0, void 0, function* () {
    e.preventDefault();
    state.error = null;
    state.success = false;
    if (isValidInput(state.form)) {
        const jwt = User.jwt;
        const phxid = User.getUsername();
        const password = state.form.pwd.value();
        try {
            state.submitting = true;
            yield changePassword(phxid, jwt, password);
            state.success = true;
        }
        catch (e) {
            state.error = e;
        }
        state.submitting = false;
        m.redraw();
    }
});
export default {
    oninit({ state }) {
        state.error = null;
        state.success = false;
        state.submitting = false;
        state.form = {
            pwd: text(true),
            confirm: text(true),
        };
        state.form.confirm.mirror = state.form.pwd;
    },
    view({ state }) {
        const { pwd, confirm } = state.form;
        const btnStatusClass = getBtnStatusClass(state.success, state.error);
        return (m("div", { class: "mt3" },
            m("p", { class: "alert alert--warning alert--icon" },
                m("i", { class: "fas fa-exclamation-triangle" }),
                m("strong", null, "Anmerkung f\u00FCr interne Mitarbeiter:"),
                " Das Windows-Passwort kann \u00FCber diesen Mechanismus ",
                m("strong", null, "nicht"),
                " ",
                "ge\u00E4ndert werden!"),
            m("form", { class: "form-box", onsubmit: (e) => submit(state, e) },
                state.error && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--danger mb3" }, state.error["userfriendly-message"] ||
                        state.error["details"] ||
                        `Dein Passwort konnte nicht geändert werden,
                                bitte versuche es später erneut.`))),
                state.success && (m("div", { class: "pulse animated" },
                    m("p", { class: "alert alert--success mb3" }, "Gut gemacht! Dein Passwort wurde ge\u00E4ndert."))),
                m("label", { class: "textfield" },
                    m("input", { maxLength: "100", type: "password", name: "phxpassword", value: pwd.value(), autocomplete: "phxpassword", oninput: (e) => {
                            pwd.validate(e.target.value);
                            confirm.validate(confirm.value());
                        } }),
                    m("span", { class: `textfield__label ${pwd.complaint ? "alert--warning" : ""}` }, "neues Passwort")),
                m("label", { class: "textfield" },
                    m("input", { maxLength: "100", type: "password", value: confirm.value(), name: "phxpassword-confirm", autocomplete: "phxpassword-confirm", oninput: (e) => {
                            confirm.validate(e.target.value);
                            pwd.validate(pwd.value());
                        } }),
                    m("span", { class: `textfield__label ${confirm.complaint ? "alert--warning" : ""}` }, confirm.complaint === ValidationTypes.notequal
                        ? "noch keine Übereinstimmung"
                        : "neues Passwort wiederholen")),
                m("button", { disabled: state.submitting, class: `btn ${btnStatusClass} ma0` },
                    state.submitting ? m("i", { class: "fas fa-spinner fa-spin mr2" }) : "",
                    m("span", null, "Passwort \u00E4ndern"))),
            m("div", { class: "tr mt2" },
                m(Link, { href: "/hub", title: "zur\u00FCck zum Wegweiser", class: "btn btn--link" },
                    "\u00DCbersicht ",
                    m("i", { class: "fas fa-arrow-right ml1" })))));
    },
};
